module.exports = __webpack_public_path__ + "img/three1Green.7d531fd3.jpg";